<div class="c-modal--new-version__text">
  <span i18n="@@common.new_version_available">New version available.</span>
  <span i18n="@@common.please_update_now">Please update now.</span>
</div>
<button p500-ui-button (click)="reloadPage()" i18n="@@common.update">Update</button>
